import EventCategoryManager from './EventCategoryManager';

export default EventCategoryManager;
